<template>
  <div class="manage">
    <ul class="list">
      <li class="item">
        <span class="item__hd">手机号码</span>
        <span class="item__bd">{{ formatTel(userInfo.tel) }}</span>
        <span class="item__ft" @click="$router.push('/UpdateTel')">修改</span>
      </li>
      <li class="item">
        <span class="item__hd">微信</span>
        <span class="item__bd">未绑定</span>
        <span class="item__ft"></span>
      </li>
      <li class="item">
        <span class="item__hd">QQ</span>
        <span class="item__bd">未绑定</span>
        <span class="item__ft"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const formatTel = (tel) => {
  if (!tel) {
    return '';
  } else {
    const strList = tel.split('');
    return strList.map((item, index) => (index > 2 && index < 7) ? '*' : item).join('');
  }
};

export default {
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    formatTel
  }
};
</script>

<style lang="postcss" scoped>
.item {
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 16px;
  line-height: 22px;
  border-bottom: 1px solid #E9EBED;
  &__hd {
    width: 64px;
    float: left;
  }
  &__bd {
    float: left;
    margin-left: 60px;
    color: #999;
  }
  &__ft {
    float: right;
    color: #3782FF;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/account/manage.vue